import { Pipe, PipeTransform } from '@angular/core';
import { ApiConfiguration } from '../../api/api-configuration';

export interface AdminImageSrcOptions {
  /** Optional cache-busting or revalidation parameter appended as ?v=... */
  v?: string | number | Date;
  /** Optional fallback src when fileId/projectId missing */
  fallback?: string;
}

@Pipe({
  name: 'adminImageSrc',
  standalone: true,
})
export class AdminImageSrcPipe implements PipeTransform {
  constructor(private readonly apiCfg: ApiConfiguration) {}

  transform(
    fileId?: string | null,
    projectId?: string | null,
    opts?: AdminImageSrcOptions
  ): string {
    if (!fileId || !projectId) {
      return opts?.fallback ?? '';
    }

    const base = (this.apiCfg?.rootUrl || '/api').replace(/\/$/, '');

    let url = `${base}/v1/admin/projects/${encodeURIComponent(
      projectId
    )}/images/${encodeURIComponent(fileId)}`;

    if (opts?.v !== undefined && opts?.v !== null) {
      const vVal = opts.v instanceof Date ? opts.v.getTime() : String(opts.v);
      url += `?v=${encodeURIComponent(vVal)}`;
    }

    return url;
  }
}
